
<template>
    <div>      
        <VideoComp  v-if="ready" :x="972" :y="300" :src="video" :scale="1" />
        <VideoComp  v-if="ready && temporise" :x="10" :y="860" :src="video" :scale="1" />
    </div>
</template>

<script>

import Matter from 'matter-js'
import Mixin from '@/mixins/Experience'
import VideoComp from '@/components/VideoComp.vue'

export default {

    name: 'Petals',
    mixins: [ Mixin ],
    components: { VideoComp },

    data: () => ({
        ready: false,
        temporise: false,
        video: 'flame_100',
    }),

    beforeDestroy() { 

        this.$Body.setPosition(this['$floor'], { x: 0, y: 2000 })
        this.$World.remove(this.$world, [ this.$floor ])
        this.removeAllPetal()
    },

    created() {

        this.$container_petals = this.$parent.$container_petals 
        this.$world.gravity.y = 0.25
        this.$petals = []
        this.$need_delete = []
        this.$id = 0
        this.$rayon = 100
    },

    mounted() { 

        this.addBackground('petals') 
        this.ready = true
        TweenMax.delayedCall(0.5, ()=>{ this.temporise = true })
        this.addFloor()
    },

    methods: {

        click() {
  
            this.addPetals()
            this.$tween = TweenMax.delayedCall(1, this.click)
        },

        addBackground(arg) {

            let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/petals/bkg.png')))
                sprite.anchor.x = 0.5
                sprite.anchor.y = 0.5
                sprite.position.set(this.$width/2, this.$height/2)
                sprite.scale.set(1*this.$coef, 1*this.$coef)
            this.$background.addChild(sprite)
            this.$sprites_background.push(sprite)
            this.$bkg = sprite
            this.$tween = TweenMax.from(this.$bkg, 0.50, { alpha: 0, ease:Linear.easeNone, delay: 0.5, onComplete: this.backgroundCompleted })
        },

        backgroundCompleted() { this.addElements() 
        },

        addFlame() {

            const els = [

                { id: 'flame', x:540, y: 960, ax: 0.5, ay: 0.5 },
                { id: 'flame_1', x:540, y: 960, ax: 0.5, ay: 0.5 },
                { id: 'flame_2', x:540, y: 960, ax: 0.5, ay: 0.5 },
                { id: 'flame_3', x:540, y: 960, ax: 0.5, ay: 0.5 },
            ]

            _.each(els, (el)=>{ 

                let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/flame/'+ el.id +'.png')))
                    sprite.anchor.x = el.ax
                    sprite.anchor.y = el.ay
                    sprite.position.set(el.x*this.$coef, el.y*this.$coef)
                    sprite.scale.set(1*this.$coef, 1*this.$coef)
                    sprite.alpha = 0

                this.$foreground.addChild(sprite) 
                this.$sprites_foreground.push(sprite)
                this['$'+ el.id] = sprite  
            })

            this.motionFlame()
        },

        motionFlame() {

            this.$tempo = 0.25
            this.$tween = new TimelineMax({})
            .to(this.$flame_1, 0.5, { alpha: 1, ease: Linear.easeNone })
            .to(this.$flame_2, 0.25, { alpha: 1, ease: Linear.easeNone })
            .to(this.$flame_3, 5, { alpha: 1, ease: Linear.easeNone })
            .to(this.$flame_2, 0.25, { alpha: 1, ease: Linear.easeNone })
        },

        addElements() {

            const els = [

                { id: 'cl1', x:6, y: 590, ax: 0.5, ay: 0.5 },
                { id: 'cl2_3', x:50, y: 1876, ax: 0.5, ay: 0.5 },
                { id: 'cl2_2', x:50, y: 1876, ax: 0.5, ay: 0.5 },
                { id: 'cl2_1', x:50, y: 1876, ax: 0.5, ay: 0.5 },
                { id: 'cr1_2', x:898, y: 128, ax: 0.5, ay: 0.5 },
                { id: 'cr1_3', x:898, y: 128, ax: 0.5, ay: 0.5 },
                { id: 'cr1_4', x:898, y: 128, ax: 0.5, ay: 0.5 },
                { id: 'cr1_1', x:898, y: 128, ax: 0.5, ay: 0.5 },
                { id: 'cr2_2', x:1068, y: 756, ax: 0.5, ay: 0.5 },
                { id: 'cr2_3', x:1068, y: 756, ax: 0.5, ay: 0.5 },
                { id: 'cr2_1', x:1068, y: 756, ax: 0.5, ay: 0.5 },
                { id: 'cr3', x:1020, y: 1834, ax: 0.5, ay: 0.5 },
                { id: 'frg', x:540, y: 960, ax: 0.5, ay: 0.5 },
                { id: 'tagline_1', x:230, y: 1324, ax: 0.5, ay: 0.5 }, 
                { id: 'tagline_3', x:258, y: 1702, ax: 0.5, ay: 0.5 },
                { id: 'tagline_2', x:262, y: 1492, ax: 0.5, ay: 0.5 },
                { id: 'tagline', x:264, y: 1544, ax: 0.5, ay: 0.5 },
            ]

            _.each(els, (el)=>{ this['$'+ el.id] = this.getSprite(el) })
            this.showElements()
        },

        showElements() {

            this.$tempo = 0.25
            this.$tween = new TimelineMax({
                delay: 0.5,
                
            })
            .add([

                TweenMax.from(this.$cl1.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cl1.alpha = 1 } }),
                TweenMax.from(this.$cl1, 1.0, { rotation: -2, ease: Expo.easeOut }),

                TweenMax.from(this.$cl2_1.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cl2_1.alpha = 1 }, delay: this.$tempo }),
                TweenMax.from(this.$cl2_1, 1.0, { rotation: -2, ease: Expo.easeOut, delay: this.$tempo }),

                TweenMax.from(this.$cl2_2.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cl2_2.alpha = 1 }, delay: this.$tempo*1.25 }),
                TweenMax.from(this.$cl2_2, 1.0, { rotation: -2, ease: Expo.easeOut, delay: this.$tempo*1.25 }),

                TweenMax.from(this.$cl2_3.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cl2_3.alpha = 1 }, delay: this.$tempo*1.40 }),
                TweenMax.from(this.$cl2_3, 1.25, { rotation: -5, ease: Expo.easeOut, delay: this.$tempo*1.25 }),

                TweenMax.from(this.$cr3.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cr3.alpha = 1 }, delay: this.$tempo*3 }),
                TweenMax.from(this.$cr3, 1, { rotation: 1, ease: Expo.easeOut, delay: this.$tempo*3 }),

                TweenMax.from(this.$cr2_1.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cr2_1.alpha = 1 }, delay: this.$tempo*4 }),
                TweenMax.from(this.$cr2_1, 1, { rotation: 1, ease: Expo.easeOut, delay: this.$tempo*4 }),

                TweenMax.from(this.$cr2_3.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cr2_3.alpha = 1 }, delay: this.$tempo*4.25 }),
                TweenMax.from(this.$cr2_3, 1, { rotation: 1, ease: Expo.easeOut, delay: this.$tempo*4.25 }),

                TweenMax.from(this.$cr2_2.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cr2_2.alpha = 1 }, delay: this.$tempo*4.5 }),
                TweenMax.from(this.$cr2_2, 1.25, { rotation: 3, ease: Expo.easeOut, delay: this.$tempo*4.5, onComplete: ()=>{

                    this.click()
                } }),

                TweenMax.set(this.$frg, { alpha: 1, delay: this.$tempo*5 }),

                TweenMax.from(this.$cr1_1.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cr1_1.alpha = 1 }, delay: this.$tempo*6 }),
                TweenMax.from(this.$cr1_1, 1, { rotation: 3, ease: Expo.easeOut, delay: this.$tempo*6 }),

                TweenMax.from(this.$cr1_2.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cr1_2.alpha = 1 }, delay: this.$tempo*6.25 }),
                TweenMax.from(this.$cr1_2, 1, { rotation: 3, ease: Expo.easeOut, delay: this.$tempo*6.25 }),

                TweenMax.from(this.$cr1_3.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cr1_3.alpha = 1 }, delay: this.$tempo*6.50 }),
                TweenMax.from(this.$cr1_3, 1, { rotation: 3, ease: Expo.easeOut, delay: this.$tempo*6.50 }),

                TweenMax.from(this.$cr1_4.scale, 1.0, { x: 0, y: 0, ease: Expo.easeOut, onStart: ()=>{  this.$cr1_4.alpha = 1 }, delay: this.$tempo*6.50 }),
                TweenMax.from(this.$cr1_4, 1.5, { rotation: 5, ease: Expo.easeOut, delay: this.$tempo*6.50 }),

                TweenMax.from(this.$tagline_1, 0.5, { alpha: 0, ease: Linear.easeNone, delay: this.$tempo*5.5  }),
                TweenMax.from(this.$tagline_2, 1, { alpha: 0, y: '+=70', ease: Expo.easeOut, delay: this.$tempo*6  }),
                TweenMax.from(this.$tagline_3, 1, { alpha: 0, y: '+=70', ease: Expo.easeOut, delay: this.$tempo*6.5  }),
                TweenMax.to(this.$parent.$black, 0.5, { alpha: 0, ease: Linear.easeNone, onComplete: ()=>{ this.$parent.resetRecord(10) }, delay: this.$tempo*9 }),   
                TweenMax.from(this.$tagline, 1, { alpha: 0, delay: this.$tempo*7.8  })
    
            ])
                  
        },

        getSprite(data) {

            const sp = data.id.split('_')
            const id = (sp[0] == 'tagline' && sp.length>1) ? ('tagline/'+ sp[1])  : data.id

            let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/petals/'+ id +'.png')))
                sprite.anchor.x = data.ax
                sprite.anchor.y = data.ay
                sprite.position.set(data.x*this.$coef, data.y*this.$coef)
                sprite.scale.set(1*this.$coef, 1*this.$coef)
                // sprite.alpha = 0

            if(data.target === 'foreground') { 
                this.$foreground.addChild(sprite) 
                this.$sprites_foreground.push(sprite)
            } else { 
                this.$background.addChild(sprite) 
                this.$sprites_background.push(sprite)
            }
            return sprite
        },

        updatePetal(petal) {
            if(petal.alive) {
                const delay = this.getTime(petal.time)
                petal.sprite.position.x = petal.body.position.x
                petal.sprite.position.y = petal.body.position.y
                petal.sprite.rotation = petal.body.angle
                // if(petal.sprite.position.y >= this.$height + 50) 
                if(delay >= 12000 && petal.sprite.position.y > 800) 
                    this.removePetal(petal)
            }
        },

        getTime(old) {
            const d = new Date()
            const n = d.getTime()
            return n - old
        },

        removePetal(petal) {
            petal.alive = false
            this.$World.remove(this.$world, [ petal.body ])
            this.$need_delete.push(petal.sprite)
            // this.$container_petals.removeChild(petal.sprite)
        },

        removeAllPetal() { 

            _.each(this.$petals, (petal)=>{ this.removePetal(petal) })
            _.each(this.$need_delete, (sprite)=>{ this.$container_petals.removeChild(sprite) })
            // this.$World.remove(this.$world, [ this.$floor ])
        },

        addPetals() {

            const nb = _.random(2, 4)/this.$coef
            for(var i=0; i< nb; i++) {

                const size = _.random(25, 75)
                const px = _.random(20, this.$width-20) 
                const py = _.random(-100, -300)
                const ratio = size/100

                const petal = this.$Bodies.polygon(px, py, 6, size, { 
                    restitution: 0.8,
                    collisionFilter: { category: 0x0002, mask: 0x0001 }
                })

                this.$World.add(this.$world, [ petal ])
                this.$Body.setAngularVelocity(petal, 0.05)

                if(this.$parent.$debug) return

                const pet = _.random(0,2)

                let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/petal/petal_'+ pet +'.png')))
                    sprite.anchor.x = 0.5
                    sprite.anchor.y = 0.5
                    sprite.position.set(px, py)
                    sprite.scale.set(ratio, ratio)
                    sprite.rotation = (Math.PI/_.random(0, 20))
                    
                this.$container_petals.addChild(sprite)

                const d = new Date()
                const n = d.getTime()

                let obj = {
                    id: this.$id,
                    alive: true,
                    body : petal,
                    sprite: sprite,
                    time: n
                }

                this.$petals.push(obj)
                this.$id += 1
            }
   
        },

        addFloor() {

            this.$floor = this.$Bodies.rectangle(540, 1840, 1080, 80, { restitution: -0.5 , collisionFilter: { category: 0x0001 }, isStatic: true })
            this.$World.add(this.$world, [ this.$floor ])
        },

        animate() {

            if(this.$petals.length > 0) {
                _.each(this.$petals, (petal)=>{ this.updatePetal(petal) })
            }
        },
    }
}
</script>